import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getCustomerList = createAsyncThunk('customer/getCustomerList',
  async ({status, search, invoiceOverdue, pageMeta, sizeMeta, sortMeta, isAll}: CustomerListQuery) => {
    const url = `v1/customers${serializeQueryParam({status, search, isInvoiceOverdue: invoiceOverdue, page: pageMeta, size: sizeMeta, sortBy: sortMeta, isAll})}`
    const response: AxiosResponse<CustomerState> = await instance.get(url)
    return response.data
  })

export const createCustomer = createAsyncThunk('customer/createCustomer',
  async (data: CustomerPayload) => {
    const response: AxiosResponse<CustomerState> = await instance.post('v1/customers', data)
    return response.data
  })

export const editCustomer = createAsyncThunk('customer/editCustomer',
  async ({ id, data }: any) => {
    const response: AxiosResponse<CustomerState> = await instance.put(`v1/customers/${id}`, data)
    return response.data
  })

export const getCustomerSummary = createAsyncThunk('customer/getCustomerSummary',
  async (params: any) => {
    const paramText = serializeQueryParam(params)
    const url = `v1/customers/status-summary${paramText}`
    const response: AxiosResponse<CustomerSummaryState> = await instance.get(url)
    return response.data
  })
